module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/117.5011bfad.png";